import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { NgModule } from "@angular/core";
import { HttpClientModule, HttpErrorResponse } from "@angular/common/http";
import { CoreModule } from "./@core/core.module";
import { ThemeModule } from "./@theme/theme.module";
import { AppComponent } from "./app.component";
import { AppRoutingModule } from "./app-routing.module";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import {
  NbChatModule,
  NbDatepickerModule,
  NbDialogModule,
  NbMenuModule,
  NbSidebarModule,
  NbToastrModule,
  NbWindowModule,
  NbCardModule,
  NbInputModule,
  NbLayoutModule,
} from "@nebular/theme";
import { httpInterceptorProviders } from "./shared/services/auth/auth.interceptor";
import {
  getDeepFromObject,
  NbAuthJWTToken,
  NbAuthModule,
  NbPasswordAuthStrategy,
  NbPasswordAuthStrategyOptions,
} from "@nebular/auth";
import { AuthGuard } from "./shared/services/auth/auth.guard";
import { LeafletModule } from "@asymmetrik/ngx-leaflet";
import { NbRoleProvider, NbSecurityModule } from "@nebular/security";
import { RoleProvider } from "./shared/services/role.provider";
import { environment } from '../environments/environment';


const formSetting: any = {
  redirectDelay: 0,
  showMessages: {
    success: true,
  },
};

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    NbSidebarModule.forRoot(),
    NbMenuModule.forRoot(),
    NbDatepickerModule.forRoot(),
    NbDialogModule.forRoot(),
    NbWindowModule.forRoot(),
    NbToastrModule.forRoot(),
    NbChatModule.forRoot({
      messageGoogleMapKey: "AIzaSyA_wNuCzia92MAmdLRzmqitRGvCF7wCZPY",
    }),
    CoreModule.forRoot(),
    ThemeModule.forRoot(),
    FormsModule,
    ReactiveFormsModule,
    NbAuthModule.forRoot({
      strategies: [
        NbPasswordAuthStrategy.setup({
          name: "email",
          token: {
            class: NbAuthJWTToken,
            key: "token", // this parameter tells where to look for the token
          },
          baseEndpoint: environment.apiUrl,
          login: {
            redirect: {
              success: "/redirect",
              failure: null, // stay on the same page
            },
            // ...
            endpoint: "/auth/login",
          },
          register: {
            redirect: {
              success: "/",
              failure: null, // stay on the same page
            },
            // ...
            endpoint: "/auth/register",
          },
          logout: {
            endpoint: "/auth/logout",
            method: "delete",
          },
          requestPass: {
            endpoint: "/auth/request-pass",
            method: "post",
            redirect: {
              success: "/",
              failure: null,
            },
          },
          resetPass: {
            endpoint: "/auth/reset-pass",
            method: "post",
            redirect: {
              success: "/",
              failure: null,
            },
            resetPasswordTokenKey: "reset_password_token",
          },
          refreshToken: {
            endpoint: "refresh-token",
            method: "post",
            requireValidToken: true,
            redirect: {
              success: null,
              failure: null,
            },
            defaultErrors: ["Something went wrong, please try again."],
            defaultMessages: ["Your token has been successfully refreshed."],
          },
          errors: {
            key: "data.errors",
            getter: (
              module: string,
              res: HttpErrorResponse,
              options: NbPasswordAuthStrategyOptions
            ) =>
              getDeepFromObject(
                res.error,
                options.errors.key,
                options[module].defaultErrors
              ),
          },
        }),
      ],
      forms: {
        login: formSetting,
        register: formSetting,
        requestPassword: formSetting,
        resetPassword: formSetting,
        logout: {
          redirectDelay: 500,
        },
      },
    }),
    LeafletModule,
    NbInputModule,
    NbCardModule,
    NbLayoutModule,
    NbDatepickerModule.forRoot(),
    NbSecurityModule.forRoot({
      accessControl: {
        User: {
          view: "nothing",
        },
        HospitalStaff: {
          view: ["devices", "distributors"],
        },
        Distributor: {
          view: ["devices", "sales", "options", "locations", "hospital-staff"],
          create: ["sales", "hospital-staff"],
          update: ["sales"],
          upload: ["files"],
        },
        Manufacturer: {
          view: [
            "devices",
            "sales",
            "distributors",
            "options",
            "locations",
            "hospital-staff",
          ],
          create: ["sales", "distributors"],
          update: ["sales", "users", "devices"],
        },
        Admin: {
          create: "*",
          view: "*",
          remove: "*",
          update: "*",
          upload: "*",
        },
      },
    }),
  ],
  providers: [
    httpInterceptorProviders,
    AuthGuard,
    { provide: NbRoleProvider, useClass: RoleProvider }, // provide the class
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
function observableOf(arg0: string) {
  throw new Error("Function not implemented.");
}
